require('./bootstrap');

window.Vue = require('vue').default;

Vue.component('courses-table', require('./components/app/Courses/Table.vue').default);
Vue.component('modules-table', require('./components/app/Modules/Table.vue').default);
Vue.component('topics-table', require('./components/app/Topics/Table.vue').default);
Vue.component('questions-table', require('./components/app/Questions/Table.vue').default);
Vue.component('assigncourse-table', require('./components/app/AssignCourse/Table.vue').default);
Vue.component('container', require('./components/app/MyCourse/Container.vue').default);
Vue.component('definitions-table', require('./components/app/Definitions/Table.vue').default);
Vue.component('logstudents-table', require('./components/app/ActivityStudents/Table.vue').default);
Vue.component('register', require('./components/app/Auth/Register.vue').default);
// Campo de fecha de la app: muestra dd/mm/aaaa y entrega "YYYY-MM-DD" al backend.
// Usar <date-field> en lugar de <input type="date">, cuyo formato visible depende
// del locale del navegador.
Vue.component('date-field', require('./components/app/Shared/DateField.vue').default);
Vue.component('general-panel', require('./components/app/General/Panel.vue').default);
Vue.component('users-table', require('./components/app/Users/Table.vue').default);
Vue.component('roles-table', require('./components/app/Roles/Table.vue').default);
Vue.component('activitylogs-table', require('./components/app/ActivityLogs/Table.vue').default);
Vue.component('dashboard-panel', require('./components/app/Dashboard/Panel.vue').default);
Vue.component('studentprogress-table', require('./components/app/StudentProgress/Table.vue').default);
Vue.component('student-dashboard', require('./components/app/Dashboard/StudentPanel.vue').default);


import axios from 'axios';


const app = new Vue({
    el: '#app',
});